<div
  class="rounded-[12px] border-neutrals-300 bg-white box-border p-5 grid grid-flow-row gap-3"
>
  <div class="flex justify-between">
    <ui-headline
      type="h14"
      mobile-type="h14"
      font-weight="semibold"
      text-color="neutrals-700"
      content="Cotizaciones"
    />
    <div class="grid grid-flow-col gap-2">
      <button>
        <ui-icon name="chevron-up" fill="neutrals-600" m-size="24" size="24" />
      </button>
    </div>
  </div>

  <div
    class="grid grid-flow-row gap-2 py-3 px-4 border-neutrals-300 rounded-[8px]"
  >
    <div class="grid grid-flow-row gap-2" *ngFor="let item of [0, 1, 2, 3]">
      <div
        class="grid grid-flow-col gap-3 py-1 rounded-[8px] justify-between items-center"
      >
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-900"
          content="54787_ConBomba..."
        />
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-900"
          content="05/10/23"
        />
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-900"
          content="S/ 4,983.00"
        />
        <button class="bg-neutrals-200 p-2 rounded-[8px]">
          <ui-icon
            name="vertical-menu"
            fill="neutrals-900"
            m-size="16"
            size="16"
          />
        </button>
      </div>
      <div
        class="block h-[1px] w-full bg-neutrals-300"
        *ngIf="item !== 3"
      ></div>
    </div>
  </div>

  <button
    class="btn-primary hover:shadow-lg grid gap-2 justify-center items-center"
    *ngIf="btn"
  >
    <ui-icon name="plus" fill="primary-700" m-size="24" size="24" />
    Generar Cotización
  </button>
</div>
